import {getMaxMinTipVolumeAllowed, getTipVolumeAndAspirateSequence} from 'lib/virtualTrayHelper';
import {TaskType, TrayType} from 'constants/dataEnum';
import {getCardById, getSelectedCardSelector} from 'stores/selectors/cardStateSelector';

import {getAspirateDispenseVolumeModalData} from 'stores/selectors/virtualTraySelectors';
import {hideAspirateDispenseVolumeModal, setAspirateDispenseVolumeModal} from 'stores/actions/virtualTrayAction';
import {getDeckNumber} from 'contents/ProtocolEditor/VirtualTray/labwareHelper';
import {isEmpty} from 'lodash';

// #region aspirateDispense modal
const headerHeight = 64;

export const calculateADModalPos = (deckNumber) => (dispatch, getState) => {
  const {virtualTrayState} = getState();
  const {deckLabwareRefs} = virtualTrayState;

  const deckLabwarePos = deckLabwareRefs[deckNumber].current.getBoundingClientRect();

  const {top, left} = deckLabwarePos;

  const xOffset = 138;
  const yOffset = 25;

  const topOffset = top - headerHeight + yOffset;
  const leftOffset = left - xOffset;

  return {top: topOffset, left: leftOffset};
};

export const checkTipVolume = (selectedCard, task) => (dispatch, getState) => {
  const {
    cardState,
    configState,
    protocolState: {lastOpenedProtocol},
  } = getState();
  const {tasks} = cardState;
  const {maxAspirateVolume, maxAspirateHighVolume} = configState;

  const trayMaxAspirateVolume =
    lastOpenedProtocol.trayType === TrayType.HIGH_VOLUME_CADDY ? maxAspirateHighVolume : maxAspirateVolume;

  const volumeAndSequence = getTipVolumeAndAspirateSequence(selectedCard, tasks, {newTask: task});
  const {tipVolume, tipVolumeSequence} = volumeAndSequence;

  const isAirGapTaskExists = Boolean(tipVolumeSequence.find((seq) => seq.type === TaskType.AIR_GAP));
  const isAddingNewAirGapTask = task.type === TaskType.AIR_GAP;
  const addingOrEditingMixingTask = task.type === TaskType.MIXING;
  const getMaxMinVolOpt = {
    airGap: {
      isExistsOnCard: isAirGapTaskExists,
      isNewTask: isAddingNewAirGapTask,
    },
    addingOrEditingMixingTask,
  };

  const volumeBoundary = getMaxMinTipVolumeAllowed(tipVolume, trayMaxAspirateVolume.value, getMaxMinVolOpt);
  const {minimumAllowedVolume, maximumAllowedVolume} = volumeBoundary;

  return [tipVolume, minimumAllowedVolume, maximumAllowedVolume, tipVolumeSequence];
};

export const checkTipVolumeAndShowAspirateDispenseModal =
  (selectedCard, task, onApplyCallback) => (dispatch, getState) => {
    let selectedCardState = selectedCard;
    // this is to ensure that the selectedCard is up-to-date if it is not passed as an argument or if it is empty (OP#71909)
    if (!selectedCardState || isEmpty(selectedCardState)) {
      [selectedCardState = {}] = getSelectedCardSelector(getState());
    }

    const upToDateSelectedCard = selectedCard ? getCardById(selectedCardState.ID)(getState()) : selectedCardState;
    const {type, volume} = task;

    const tipVolumeStatus = dispatch(checkTipVolume(upToDateSelectedCard, task));
    const [initialTipVolume, minVolume, maxVolume, tipVolumeSequence] = tipVolumeStatus;

    const initialVolume =
      type === TaskType.ASPIRATE || type === TaskType.MIXING || type === TaskType.AIR_GAP ? volume : volume * -1;

    const deckNumber = getDeckNumber(task.labwareID);
    const position = dispatch(calculateADModalPos(deckNumber));

    dispatch(
      setAspirateDispenseVolumeModal({
        isShown: true,
        initialTipVolume,
        volume: initialVolume,
        initialTaskType: type,
        taskType: type,
        minVolume,
        maxVolume,
        tipVolumeSequence,
        onApplyCallback,
        position,
      }),
    );
  };

export const setVolumeAspirateDispenseModal = (newVolume) => (dispatch, getState) => {
  const {virtualTrayState} = getState();
  const {aspirateDispenseVolumeModal} = virtualTrayState;

  dispatch(setAspirateDispenseVolumeModal({...aspirateDispenseVolumeModal, volume: newVolume}));
};

export const setTaskTypeAspirateDispenseModal = (taskType) => (dispatch, getState) => {
  const {virtualTrayState} = getState();
  const {aspirateDispenseVolumeModal} = virtualTrayState;

  dispatch(setAspirateDispenseVolumeModal({...aspirateDispenseVolumeModal, taskType}));
};

const apply = () => async (dispatch, getState) => {
  const data = getAspirateDispenseVolumeModalData(getState());
  const {onApplyCallback, volume, taskType, isShown} = data || {};

  if (!isShown) return;

  if (onApplyCallback) await onApplyCallback({volume: Math.abs(volume), taskType});
  dispatch(hideAspirateDispenseVolumeModal());
};

export const AspirateDispenseVolumeModalBusiness = {
  apply,
};
